var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redesign-root"},[_c('div',{staticClass:"screen-card"},[_c('main',{staticClass:"body-wrap"},[_c('router-view')],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"brand-footer"},[_c('img',{attrs:{"src":require("@/assets/images/trendlife-wordmark.svg"),"alt":"TrendLife","width":"110","height":"20"}})])
}]

export { render, staticRenderFns }